import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotFound from '../components/NotFound';
import LoginScreen from '../screens/Login/LoginScreen';
import { InspectorRoutes, PublicRoutes, SuperAdminRoutes, } from './Routes';
import { RouteConstant } from './RouteConstant';
import PageLayout from '../screens/Layout/PageLayout';
import SnackContainer from '../components/SnackContainer';

const AppRoutes = () => {

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const role = useSelector((state) => state.auth.user?.role?.role);

  const protectedRoutes = role === 'SADMIN' ? SuperAdminRoutes : role === 'MANAGER' ? SuperAdminRoutes : role === 'INSPECTOR' ? InspectorRoutes : [];

  return (
    <>
        <Routes>
            {PublicRoutes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
            ))}

            {isAuthenticated && (
                <Route path={RouteConstant.ROOT} element={<PageLayout />}>
                    {protectedRoutes.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                </Route>
            )}
            {!isAuthenticated && <Route path={RouteConstant.ROOT} element={<LoginScreen />} />}
            <Route path="*" element={<NotFound />} />
        </Routes>
    </>
  );
};

export default AppRoutes;